export const TERMS_AND_CONDITIONS = [
  {
    service: 'SngKiosk',
    acceptance: 'y',
  },
]
export const SNG_REQUEST_ORIGIN = {
  requestorigin: 'sng_kiosk',
}

export const isWildebeestOrigin = (referrer = document.referrer) => {
  if (referrer.startsWith('https://app.') || referrer.startsWith('http://www-dev.asda.com')) return true
  return false
}

export const getKioskUrl = (
  host = window.location.host,
  referrerUrl = document.referrer,
  isWildebeest = isWildebeestOrigin(),
) => {
  if (host === 'www.int.asda.com' && !isWildebeest) {
    return `https://app.prod-lb.kiosk.asdasagm.glb.uk.walmart.net/`
  } else if (referrerUrl) {
    if (referrerUrl.endsWith('Admin/')) {
      return referrerUrl.replace('Admin/', '')
    }
    if (referrerUrl.endsWith('Admin')) {
      return referrerUrl.replace('Admin', '')
    }
    if (referrerUrl.endsWith('colleaguemenu/')) {
      return referrerUrl.replace('colleaguemenu/', '')
    }
    if (referrerUrl.endsWith('colleaguemenu')) {
      return referrerUrl.replace('colleaguemenu', '')
    }
    if (!referrerUrl.endsWith('/')) {
      return `${referrerUrl}/`
    }
    return referrerUrl
  }
  return `https://app.stg.kiosk.asdasagm.glb.uk.walmart.net/`
}

export const TNC_UPDATED_DATE = '23/06/2017'
